module.exports = __webpack_public_path__ + "img/backend.abdf5b01.png";